import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast = {

  success: (message) => toast.success(message, {
    autoClose: 4000,
    closeButton: false,
    hideProgressBar: false,
    progressStyle: { backgroundColor: 'green' }
  }),
  error: (message) => toast.error(message, {
    autoClose: 3000,
    closeButton: true,
    hideProgressBar: true
  }),
  login: (message) => toast.success(message, {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true
  }),
  display: (message) => toast.success(message, {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
    progressStyle: { backgroundColor: 'green' }
  }),
  show: (message) => toast.success(message, {
    autoClose: 10000,
    closeButton: true,
    hideProgressBar: true,
    progressStyle: { backgroundColor: 'green' }
  }),
  info: (message) => toast.info(message, {
    autoClose: 1000,
    closeButton: true,
    hideProgressBar: true,
    progressStyle: { backgroundColor: 'blue' }
  }),
};

export default Toast;